<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36"><g style="stroke:#d2d3d6;fill:#fff"><circle cx="18" cy="18" r="18" stroke="none" style="stroke:none"/><circle cx="18" cy="18" r="17.5" style="fill:none"/></g><path d="m0 10 4-5-4-5" style="stroke:currentColor;stroke-linecap:round;stroke-miterlimit:10;stroke-width:2px;fill:none" transform="translate(16.501 13)" fill="currentColor"/><path d="M9 0H0" style="stroke:currentColor;stroke-linecap:round;stroke-miterlimit:10;stroke-width:2px;fill:none" transform="translate(10 18)" fill="currentColor"/><path d="M0 0v11" style="stroke:currentColor;stroke-linecap:round;stroke-miterlimit:10;stroke-width:2px;fill:none" transform="translate(23.501 12.5)" fill="currentColor"/></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-lnb-open',
});
</script>
